import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './SupplierForm.css';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

// Add-only — editing an existing Supplier's Name/Currency happens on its own
// detail page (CommercialEntityDetailPage.js's Currency card/kebab), not
// through this form. Asks for Currency only: exchange rates are reference
// rates per currency, shared system-wide (issue #303).
function SupplierForm({ onSave, onCancel, loading }) {
  const [name, setName] = useState('');
  const [currencyCode, setCurrencyCode] = useState('');
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('/api/currencies', { params: { limit: 100, status: 'active' } })
      .then((res) => setCurrencyOptions(res.data.data || []))
      .catch(() => setCurrencyOptions([]));
  }, []);

  const validate = () => {
    if (!name.trim()) return 'Supplier name is required.';
    if (!currencyCode) return 'Currency is required.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({
      name: name.trim(),
      currency_code: currencyCode,
    });
  };

  return (
    <form className="supplier-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <div>
          <label>Supplier Name<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={100}
            placeholder="e.g., Acme Supplies"
          />
        </div>
        <div>
          <label>Currency<RequiredMark /></label><br />
          <select className="styled-input" value={currencyCode} onChange={(e) => setCurrencyCode(e.target.value)}>
            <option value="">Select currency</option>
            {currencyOptions.map((c) => (
              <option key={c.currency_code} value={c.currency_code}>
                {c.currency_code} - {c.currency_name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default SupplierForm;
